/**
Author - Venkatesh Pullaganti😃
Git - https://github.com/venkatesh1146
**/

import React from 'react';
import {ProgressBar} from 'components/ProgressBar/ProgressBar';

const LoadingView = () => (
  <ProgressBar
    waitTimeInSec={30}
    loadingTexts={['Checking consent status...', 'Please wait...', 'Almost there...']}
    stopOnEndTime={false}
    heading="Loading"
    subheading="Please wait while we check your consent status"
    showShadow={false}
  />
);

export default LoadingView;
